export const openRunningWorkqueueModal = async ({ commit, dispatch }, workqueue) =>
	commit('openRunningWorkqueueModal', workqueue);

export const closeRunningWorkqueueModal = async ({ commit, dispatch }) => commit('closeRunningWorkqueueModal');
